import { Box, Button, Nav, Sidebar, Text } from "grommet"
import { useState } from "react"
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";

const SidebarComponent = ({ navs, ...props }) => {

    const location = useLocation();
    const navigate = useNavigate();

    const handleNavClick = (nav) => {
        navigate(nav.link);
    }

    return (
        <Box {...props}>
            <Sidebar>
                <Nav gap="small">
                    {navs.map(nav => (
                        <SidebarButton nav={nav} onClick={() => handleNavClick(nav)} active={location.pathname === nav.link} />
                    ))}
                </Nav>
            </Sidebar>
        </Box>
    )
}

const SidebarButton = ({ nav, active, onClick }) => {

    const { t } = useTranslation();
    const [isActiveHover, setActiveHover] = useState(false);

    return (
        <Box direction="row" fill pad={{ vertical: 'small', horizontal: '18px' }} onClick={onClick} style={{ position: "relative" }} round="xsmall" background={active ? 'background-contrast' : 'none'} hoverIndicator focusIndicator={false} onMouseEnter={() => setActiveHover(true)} onMouseLeave={() => setActiveHover(false)}>
            {(isActiveHover || active) && <Box width={'6px'} style={{ position: "absolute", left: 0, top: 0, bottom: 0, borderTopLeftRadius: '6px', borderBottomLeftRadius: '6px' }} background={'brand'}></Box>}
            <Button label={<Text style={{ whiteSpace: 'nowrap' }}>{t(nav.title)}</Text>} icon={nav.icon} plain fill justify="start" />
        </Box>
    )
}

export default SidebarComponent; 